export default __webpack_public_path__ + "static/ut-logo-d145d3f9930cc1b10d897c662a0d867a.png";